import ContentInterestModule from './containers/contentInterestModule'

export {default as ContentInterestModuleLayout} from './components/contentInterestModuleLayout'

export default ContentInterestModule
